export enum ButtonRestrictionType {
  Coupon = 'Coupon',
  Promotion = 'Promotion',
  RewardAsTender = 'RewardAsTender',
  Product = 'Product',
  Tender = 'Tender',
  NotTender = 'NotTender',
  ReturnItem = 'ReturnItem',
  NotRecall = 'NotRecall',
  All = 'All',
  QuantityGreaterThan1 = 'QuantityGreaterThan1',
  ActiveTransaction = 'ActiveTransaction',
  HasCustomer = 'HasCustomer',
  InactiveTransaction = 'InactiveTransaction',
  HasActiveProductLines = 'HasActiveProductLines',
  HasCashDrawer = 'HasCashDrawer',
  HasPinpad = 'HasPinpad',
  HasCoupons = 'HasCoupons',
  SaleModeFromReturnMode = 'SaleModeFromReturnMode',
  TaxExemption = 'TaxExemption',
  NotProcessing = 'NotProcessing',
  OwnBagEnabled = 'OwnBagEnabled',
}
